import UserConfig from './User';

interface Filters {
  distance: number;
  order: string;
  photos: boolean;
  has_photo: boolean;
  online: boolean;
  age_min: number;
  age_max: number;
  height_min: number;
  height_max: number;
  keywords: string;
  id_verified: any[];
  selfie_verified: any[];
  smoking: any[];
  drinking: any[];
  relationship_status: any[];
  ethnicity: any[];
  body_types: any[];
  education: any[];
  children: any[];
  dating_just_dating: boolean;
  dating_friendship: boolean;
  dating_marriage: boolean;
  dating_sugar: boolean;
  dating_married: boolean;
  dating_adult: boolean;
  dating_mentorship: boolean;
  city: string;
  country: string;
  region: string;
  latitude: number | null;
  longitude: number | null;
  fromDashboard?: boolean;
}

interface SearchConfig {
  profile: any[];
  newestMembers: any[];
  onlineMembers: any[];
  isFetching: boolean;
  hasFetchError: boolean;
  pgid: number | null;
  preservedResult?: any;
  filters: Filters;
  showSkeleton?: boolean;
}

const searchConfig: SearchConfig = {
  profile: [],
  newestMembers: [],
  onlineMembers: [],
  isFetching: false,
  hasFetchError: false,
  pgid: null,
  filters: {
    distance: 50,
    order: 'recent',
    photos: false,
    has_photo: false,
    online: false,
    age_min: UserConfig.minimumAge,
    age_max: UserConfig.maximumAge,
    height_min: UserConfig.minimumHeight, // in cm
    height_max: UserConfig.maximumHeight,
    keywords: '',
    id_verified: [],
    selfie_verified: [],
    smoking: [],
    drinking: [],
    relationship_status: [],
    ethnicity: [],
    body_types: [],
    education: [],
    children: [],
    dating_just_dating: false,
    dating_friendship: false,
    dating_marriage: false,
    dating_sugar: false,
    dating_married: false,
    dating_adult: false,
    dating_mentorship: false,
    city: '',
    country: '',
    region: '',
    latitude: null,
    longitude: null,
  },
  showSkeleton: false,
};

export default searchConfig;
